export default "__VITE_ASSET__D0WKkkkK__"